import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SearchDropdownComp from 'components/SearchDropdown/SearchDropdown';
import PSTNSearchBar from 'components/PSTN/PSTNSearchBar';
import PSTNSearchResults from 'components/PSTN/PSTNSearchResults';
import ReactSpinner from 'react16-spinjs';
import _memoize from 'lodash/memoize';
import classes from './PSTN.module.scss';
import { hooks } from '@lifesize/clients.sdk';

const getSearchResults = _memoize((search, countryList) => {
  if (search) {
    return countryList.filter(country =>
      (country.countryName || country.phoneNumber) &&
      (country.countryName.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
        country.countryCode.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
        country.phoneNumber.indexOf(search) !== -1)
    );
  }
  return countryList;
});

class PSTN extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      blurred: false,
      phoneNumbers: null
    };
  }

  componentDidMount = async () => {
    const phoneNumbers = await this.props.getPSTNNumbers();
    this.setState({
      phoneNumbers
    });
  };

  blurInput = () => {
    this.setState({ blurred: !this.state.blurred });
  };

  handleEnter = (searchResults) => {
    this.props.selectCountry(searchResults[this.props.selectionIndex]);
    this.blurInput();
  };

  renderSearchDropdown = () => {
    if (this.state.phoneNumbers) {
      const searchResults = getSearchResults(this.props.searchString, this.state.phoneNumbers);
      const selectedCountry = this.props.selectedCountry || this.props.preferredNumber;
      const maxItems = Math.min(searchResults.length, this.state.phoneNumbers.length, 6);

      return (
        <SearchDropdownComp
          buttonComponent={
            <PSTNSearchBar
              {...this.props}
              selectedCountry={selectedCountry}
              blurInput={this.blurInput}
              blurred={this.state.blurred}
            />
          }
          menuComponent={
            <PSTNSearchResults
              {...this.props}
              maxItems={maxItems}
              selectedCountry={selectedCountry}
              handleEnter={() => {
                this.handleEnter(searchResults);
              }}
              selectedContact={selectedCountry}
              searchResults={searchResults}
            />
          }
          isVisible={this.props.isVisible}
          clickOutsideHandler={this.props.handleBlur}
        />
      );
    }

    return (
      <div className={classes.spinnerContainer}>
        <ReactSpinner
          config={{
            lines: 13,
            length: 3,
            width: 3,
            radius: 5,
            color: '#4b45da',
            speed: 0.7
          }}
        />
      </div>
    );
  };

  renderJoinFlow() {
    const helperTextClasses = [
      classes.helperText,
      this.props.titleClass
    ].join(' ');

    return (
      <div data-testid={'joinFlow-pstn'} className={`${classes.PSTNContainer} ${this.props.isJoinFlowCall ? classes.joinFlow : ''}`}>
        <div className={helperTextClasses}>
          <FormattedMessage
            id="components.PSTNComponent.dropdown.label"
            defaultMessage="Choose your location and call in on your phone:"
          />
        </div>
        {this.renderSearchDropdown()}
        <div className={helperTextClasses}>
          <FormattedMessage
            id="components.PSTNComponent.extension.label"
            defaultMessage="Then enter this extension:"
          />
        </div>
        <input className={classes.extension} value={this.props.extension} disabled="disabled" />
      </div>
    );
  }
  renderInCallPSTN() {
    return (
      <div>
        <div className={classes.subHeading}>
          <FormattedMessage
            id="components.avSettingsModal.PSTNAudioHeader"
            defaultMessage="Audio"
          />
        </div>
        <div className={classes.pstnDetails}>
          <FormattedMessage
            id="components.avSettingsModal.PSTNdetails"
            defaultMessage="You are currently dialed in by phone."
          />
        </div>
        <div className={classes.microphoneSwitch}>
          To listen through your computer, hang up and then
          <button
            className={classes.switchButton}
            onClick={() => this.props.onSwitchToComputerAudio()}
          >
            switch to computer audio.
          </button>
        </div>
      </div>
    );
  }
  render() {
    return (this.props.isInCall ? this.renderInCallPSTN() : this.renderJoinFlow());
  }
}

export default function PSTNNew(props) {
  const callConnected = hooks.useCallConnected();
  return (
    <PSTN {...props} isInCall={callConnected} />
  );
}

PSTN.propTypes = {
  extension: PT.string.isRequired, //
  getPSTNNumbers: PT.func, //
  handleBlur: PT.func.isRequired, //
  handleFocus: PT.func.isRequired, //
  isInCall: PT.bool, // op
  isJoinFlowCall: PT.bool, // op
  isVisible: PT.bool.isRequired, //
  onSwitchToComputerAudio: PT.func, //
  preferredNumber: PT.string, //
  searchString: PT.string, //
  selectCountry: PT.func.isRequired, //
  selectedCountry: PT.oneOfType([PT.string, PT.number]), //
  selectionIndex: PT.number, //
  titleClass: PT.string, // op
};
